// Candidate profile exports (bundle 4e), both from the profile's "⋯" menu:
// - Download profile (PDF): a one-to-two-page summary to share with a hiring manager. The server builds the content
//   (pay only with access to the job, contacts left out on request) and audits it; jsPDF renders it here.
// - Download data (privacy request): company admins only — everything held about the person, as JSON (audited).
import { api } from '../components/ui/Kit';
import { jobToPdf } from './jobExport';

const ICON = { pass: '✓', fail: '✗', unknown: '?' };
const RATING = [['strong', 'Strong'], ['ok', 'OK'], ['weak', 'Weak'], ['no_answer', 'No answer']];
const RESULT = { pass: 'Pass', hold: 'Hold', fail: 'Fail' };
const day = (iso) => (iso ? new Date(iso.endsWith('Z') || iso.includes('+') ? iso : `${iso}Z`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '');

export function profileBlocks(d) {
  const c = d.candidate;
  const b = [{ t: 'note', text: `Quali5d · Candidate profile · Confidential${d.hide_contacts ? ' · contact details left out' : ''}` },
    { t: 'title', text: c.name }];
  const line = [c.title, c.company, c.location, c.years != null ? `${c.years} yrs` : null].filter(Boolean).join(' · ');
  if (line) b.push({ t: 'p', text: line });
  if ((d.contacts || []).length) b.push({ t: 'p', text: d.contacts.map((x) => x.value).join(' · ') });
  b.push({ t: 'note', text: `Candidate ID ${c.code}${d.job ? ` · for ${d.job.req_id ? `${d.job.req_id} – ` : ''}${d.job.title}` : ''} · ${day(d.generated_at)}` });
  const m = d.match;
  if (m) {
    b.push({ t: 'h', text: 'Match' });
    if (m.grade) b.push({ t: 'p', text: `Grade ${m.grade} · ${Math.round(m.total)}%` });
    else b.push({ t: 'p', text: m.status === 'not_scored' ? 'Doesn’t meet every must-have (not AI-scored)' : 'Not scored yet' });
    if (m.why) b.push({ t: 'p', text: m.why });
    if ((m.must_haves || []).length) {
      const met = m.must_haves.filter((x) => x.result === 'pass').length;
      b.push({ t: 'sub', text: `Must-haves · ${met} of ${m.must_haves.length} met` },
        { t: 'table', head: ['', 'Must-have', 'Detail'], rows: m.must_haves.map((x) => [ICON[x.result] || '?', x.label, x.detail || '']) });
    }
  }
  if ((d.key_facts || []).length) {
    b.push({ t: 'h', text: 'Key facts' }, { t: 'table', head: ['Fact', 'Value'], rows: d.key_facts.map((x) => [x.label, x.text]) });
  }
  if ((d.experience || []).length) {
    b.push({ t: 'h', text: 'Experience' },
      { t: 'bullets', items: d.experience.map((e) => [e.title, e.company].filter(Boolean).join(' · ') + (e.when ? ` (${e.when})` : '')) });
  }
  if ((d.skills || []).length) b.push({ t: 'h', text: 'Skills' }, { t: 'p', text: d.skills.join(' · ') });
  const s = d.screen;
  if (s && s.saved_at) {
    const counts = RATING.filter(([k]) => (s.counts || {})[k]).map(([k, l]) => `${s.counts[k]} ${l}`).join(' / ');
    b.push({ t: 'h', text: 'Recruiter screen' },
      { t: 'p', text: [`Result: ${RESULT[s.result] || s.result}`, counts, `${s.red_flags || 0} red flag${s.red_flags === 1 ? '' : 's'}`,
        `${day(s.saved_at)}${s.saved_by_name ? ` by ${s.saved_by_name}` : ''}`].filter(Boolean).join(' · ') });
    if (s.notes) b.push({ t: 'p', text: s.notes });
  }
  b.push({ t: 'note', text: 'Scores never reject anyone — the recruiter decides. Shared for hiring purposes only.' });
  return b;
}

export const profileFileName = (code, name) => `${[code, String(name || 'candidate').replace(/[^A-Za-z0-9]+/g, '_').replace(/^_|_$/g, '')].filter(Boolean).join('_')}_profile.pdf`;

export async function downloadProfilePdf(candidateId, jobId, hideContacts) {
  const q = new URLSearchParams();
  if (jobId) q.set('job_id', String(jobId));
  if (hideContacts) q.set('hide_contacts', 'true');
  const d = await api(`/api/candidates/${candidateId}/profile-summary?${q.toString()}`);
  const doc = await jobToPdf(profileBlocks(d));
  doc.save(profileFileName(d.candidate.code, d.candidate.name));
  return d;
}

export async function downloadPrivacyData(c) {
  const d = await api(`/api/candidates/${c.id}/export`);
  const url = URL.createObjectURL(new Blob([JSON.stringify(d, null, 2)], { type: 'application/json' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${c.candidate_code || 'candidate'}-data.json`;
  a.click();
  URL.revokeObjectURL(url);
  return d;
}
